const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-50 to-teal-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              ayuda<span className="text-teal-500">domiciliogc</span>.es
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Servicios profesionales de limpieza, mantenimiento y cuidado del hogar en toda la isla de Gran Canaria.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-teal-500 text-white rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <a href="#servicios" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Limpieza del hogar
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Cuidado de personas mayores
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Mantenimiento
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Planchado
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Sobre nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonios')}
                  className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer"
                >
                  Testimonios
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Trabaja con nosotros
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-teal-500 mt-0.5"></i>
                <span className="text-sm text-gray-600">
                  Toda la isla de Gran Canaria
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-teal-500"></i>
                <a href="tel:+34629482566" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  629 482 566
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-teal-500"></i>
                <a href="mailto:info@ayudadomiciliogc.es" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                  info@ayudadomiciliogc.es
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-600">
              © 2025 ayudadomiciliogc.es. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                Política de privacidad
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                Términos y condiciones
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-gray-600 hover:text-teal-500 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;